export default __webpack_public_path__ + "static/media/status_online.2f6ccac4.svg";